import { faro, LogLevel } from '@grafana/faro-web-sdk';

export const REQUEST_STARTED_MESSAGE = 'request started';

const METHOD_ATTRIBUTE = 'http.request.method';
const URL_ATTRIBUTE = 'url.full';

type RequestSpan = {
  attributes?: Record<string, unknown>;
  spanContext(): { spanId: string; traceId: string };
};

function stringAttribute(span: RequestSpan, key: string): string | undefined {
  const value = span.attributes?.[key];
  return typeof value === 'string' ? value : undefined;
}

export function logRequestStart(span: RequestSpan): void {
  const method = stringAttribute(span, METHOD_ATTRIBUTE);
  const url = stringAttribute(span, URL_ATTRIBUTE);

  faro.api.pushLog([REQUEST_STARTED_MESSAGE], {
    context: { ...(method && { method }), ...(url && { url }) },
    level: LogLevel.DEBUG,
    skipDedupe: true,
    spanContext: span.spanContext(),
  });
}
